const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_MEDIA_URL,
	pathPrefix: () => '/media-api/',

	getAvatarUrl: (_, getters) => id => `${getters.origin}/i/profile/${id}.jpg`,
}

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},

	async requestSpaceLogoUrl({dispatch}, spaceId) {
		// this is hacky, but we query the location to retrieve the space image
		let res = await dispatch('api/nav/getLocation', spaceId, {root: true})
		let data = res.success

		if (!data) return null

		if (data.logo != "") return data.logo
		else return null
	},

	// possible values for type:
	// spaceCoverImage spaceLogoImage mediaItemImage
	// also userAvatar, but that's covered by the other endpoint
	uploadImage({dispatch}, [file, type]) {
		let data = new FormData();
		data.append('file', file, file.name);
		data.append('imageType', type);

		return dispatch('request', {
			url: `upload/image`,
			method: 'post',
			data,
			headers: {
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
			},
		})
	},
	uploadAvatar({dispatch}, file) {
		let data = new FormData();
		data.append('file', file, file.name);

		return dispatch('request', {
			url: `upload/user-avatar-image`,
			method: 'post',
			data,
			headers: {
				'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
			},
		})
	},
	deleteAvatar({dispatch}) {
		return dispatch('request', {
			url: `upload/user-avatar-image`,
			method: 'delete'
		})
	}
}

const libraryGetters = {
	contentLocationId: (state, getters, rootState, rootGetters) => rootGetters['routing/routeName'] === 'room' ? rootGetters.getCurrentLocationId : rootGetters.getCurrentAreaId,
}

const libraryActions = {
	request({dispatch}, data) {
		return dispatch('api/media/request', {
			...data,
			url: 'library/'+(data.url || ''),
		}, {root: true});
	},

	// filter is actually a sort, idk why it's named wrong
	// 0 is date, 1 is trending, 2 is a-z
	get({dispatch, getters}, filter){
		return dispatch('request', {
			method: 'get',
			params: {
				filter,
				collectionId: getters.contentLocationId
			}
		})
	},
	click({dispatch}, mediaItemId){
		return dispatch('request', {
			url: 'click',
			method: 'post',
			params: { mediaItemId }
		})
	},

	adminPost({getters, dispatch}, [title, description, url, imageUrl, createdAt]){
		return dispatch('request', {
			method: 'post',
			data: {
				collectionId: getters.contentLocationId,
				title, description, url, imageUrl, createdAt
			}
		})
	},
	// by putting the id at the end, this function and the above can be called by the same code
	adminUpdate({dispatch, getters}, [title, description, url, imageUrl, createdAt, id]){
		return dispatch('request', {
			method: 'put',
			data: {
				id,
				collectionId: getters.contentLocationId,
				title, description, url, imageUrl, createdAt
			}
		})
	},
	adminDelete({dispatch}, mediaItemId){
		return dispatch('request', {
			method: 'delete',
			params: { mediaItemId }
		})
	},
	adminDeleteAll({dispatch, getters}){
		return dispatch('request', {
			url: 'collection',
			method: 'delete',
			params: { collectionId: getters.contentLocationId }
		})
	},
}

export default {
	namespaced: true,
	actions,
	getters,
	modules: {
		library: {
			namespaced: true,
			getters: libraryGetters,
			actions: libraryActions
		}
	}
};
